import { emailTemplateService } from "../../services";
import { ITask } from "../../customTypings/task/Task";
import { showToastSuccess } from "../../utils";
import { addTaskToCalender } from "../../utils/helpers/tasks";
import mapEmailBody from "../../pages/Task/Mapping";

export const useTaskAddEmail = (
  currentUser: any,
  adminEmail: string,
  taskTemplate: any,
  emailTemplate: any
) => {
  const actioner = `${currentUser?.identity.displayName}: ${currentUser?.identity.email}`;

  const buildReceiverEmails = (personalEmail: string | undefined) => {
    const emails: string[] = [];
    if (taskTemplate.taskCreator && currentUser?.identity.email) {
      emails.push(currentUser.identity.email);
    }
    if (taskTemplate.adminEmail && adminEmail) {
      emails.push(adminEmail);
    }
    if (taskTemplate.personnel && personalEmail) {
      emails.push(personalEmail);
    }
    return emails;
  };

  const handleTaskSuccess = async (response: any, newTask: ITask, allUsers: any[]) => {
    showToastSuccess("Task added successfully!");

    if (newTask.addToCalendar) {
      addTaskToCalender(response.id);
    }

    const pEmails: string[] = [];
    newTask.userId?.forEach((user) => {
      const personal = allUsers?.find((item: any) => item.value === user)?.label;
      if (personal?.includes(": ")) {
        pEmails.push(personal.split(": ")[1]);
      }
    });

    const emailBody = emailTemplate.body;
    const emailSubject = emailTemplate.subject;

    for (const email of pEmails.length > 0 ? pEmails : [undefined]) {
      const receiverEmails = buildReceiverEmails(email);
      if (receiverEmails.length === 0) {
        continue;
      }
      const updatedBody = await mapEmailBody({ body: emailBody, id: response.id, actioner });
      const updatedSubject = await mapEmailBody({ body: emailSubject, id: response.id, actioner });
      await emailTemplateService.sendAutoEmail(updatedSubject, updatedBody, receiverEmails);
    }
  };

  return {
    actioner,
    handleTaskSuccess,
  };
};
